<template>
    <div class="ctask-info" v-if="taskPosition">
        <div class="ctask-label">
            <label :style="{'color': statusChange(ctaskData.status)}"><i class="fa fa-stop" aria-hidden="true"></i></label>
        </div>
        <div class="ctask-left">
            <div>
                <span>任务-{{ctaskData.task_children_id}}</span>
                <span class="ctask-api-name" v-if="typeof ctaskData.task_children_info[0] !== 'undefined'">{{ctaskData.task_children_info[0].name}}</span>
                <span class="ctask-api-name" v-if="typeof ctaskData.task_children_info[1] !== 'undefined'">{{ctaskData.task_children_info[1].name}}</span>
                <span>{{closeEndTime}}</span>
            </div>
            <div class="ctask-top">
                <div class="ctask-top-left">
                    <div class="ctask-progress" v-if="taskPosition[taskId] && taskPosition[taskId][this.ctaskData.task_children_id] && taskPosition[taskId][this.ctaskData.task_children_id].hasOwnProperty('mt')">
                        <el-progress :color="'#00cec9'" :stroke-width="6" :percentage="positionRate" :show-text="false"></el-progress>
                    </div>
                    <span :style="{'color': cPositionColor}">{{cPositionData}}</span>
                </div>
                <div class="ctask-right">
                    <!-- <label :style="{'color': statusChange(ctaskData.status)}"><i class="fa fa-stop" aria-hidden="true"></i></label> -->
                    <el-dropdown trigger="click">
                        <el-button>
                            <i class="el-icon-arrow-down el-icon--right"></i>
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item @click.native="startCtask(2)">启动</el-dropdown-item>
                            <el-dropdown-item @click.native="startCtask(0)">停止</el-dropdown-item>
                            <el-dropdown-item @click.native="deleteCtask">删除</el-dropdown-item>
                            <el-dropdown-item @click.native="tradeInfo">交易详情</el-dropdown-item>
                            <el-dropdown-item @click.native="endClose()">停止平仓</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
            </div>
            <div class="ctask-trade-content" v-if="typeof taskPosition[taskId] !== 'undefined'">
                
                <div v-if="typeof taskPosition[taskId][this.ctaskData.task_children_id] !== 'undefined' && taskPosition[taskId][this.ctaskData.task_children_id].hasOwnProperty('r')">
                    <span>{{judgeNum(taskPosition[taskId][this.ctaskData.task_children_id]['r'][0][0])}} <i class="fa fa-level-down" aria-hidden="true"></i></span>
                    <span>{{judgeNum(taskPosition[taskId][this.ctaskData.task_children_id]['r'][1][0])}} <i class="fa fa-level-up" aria-hidden="true"></i></span>
                </div>
                <div v-if="typeof taskPosition[taskId][this.ctaskData.task_children_id] !== 'undefined' && taskPosition[taskId][this.ctaskData.task_children_id].hasOwnProperty('f')">
                    <span>{{judgeNum(taskPosition[taskId][this.ctaskData.task_children_id]['f'][0][0])}} <i class="fa fa-level-up" aria-hidden="true"></i></span>
                    <span>{{judgeNum(taskPosition[taskId][this.ctaskData.task_children_id]['f'][1][0])}} <i class="fa fa-level-down" aria-hidden="true"></i></span>
                </div>
                <div>
                    | <span :style="{'color': cPositionColor}">{{ctaskMarginPrice(taskPosition[taskId][this.ctaskData.task_children_id])}}%</span>/
                </div>
                <div v-if="typeof taskPosition[taskId][this.ctaskData.task_children_id] !== 'undefined' && taskPosition[taskId][this.ctaskData.task_children_id].hasOwnProperty('pro_count')">
                    <span>{{numRate(taskPosition[taskId][this.ctaskData.task_children_id]['pro_rate'])}}% / {{proCount(taskPosition[taskId][this.ctaskData.task_children_id]['pro_count'])}}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import { put, del, post } from '@/api/index'
import { mapState } from 'vuex'
import { isPositionInt } from '@/utils/common'

export default {
    data() {
        return {
            leftVisible: true,
            rightVisble: true,
            positionRate: 0,
            ctaskPositionWarn: false
        }
    },
    props: {
        ctaskData: {},
        taskId: Number,
        currency: String,
        tradeType: Object
    },
    mounted() {

    },
    computed: {
        ...mapState([
            'token',
            'taskPosition',
            'strategyParam',
            'taskCloseData',
            'ctaskWidth'
        ]),

        // 子任务持仓量判断
        cPositionData: function () {
            if (this.taskPosition) {
                if (this.taskPosition[this.taskId]) {
                    var ctask_data = this.taskPosition[this.taskId][this.ctaskData.task_children_id];
                    if (typeof ctask_data !== 'undefined') {
                        for (var i in ctask_data) {
                            if (i == 'f' || i == 'r') {// 判断持仓是否出现异常, status=true 即为异常
                                let used_position_1 = ctask_data[i][1][1];
                                let used_position_0 = ctask_data[i][0][1];
                                let position_data = isPositionInt(used_position_0, used_position_1, this.currency);
                                this.$emit('positionAbnoral', position_data.status)
                                if (this.currency == 'BTC') {
                                    this.ctaskPositionWarn = position_data.status;
                                    this.positionRate = this.positionRateCal_(Number(position_data.data)/100,  Number(ctask_data['mt'][0])/100+Number(ctask_data['mt'][1])/100)
                                    return Number(position_data.data)/100 + '/(' + Number(ctask_data['mt'][0]).toFixed(2)/100+'+'+Number(ctask_data['mt'][1]).toFixed(2)/100+')';
                                } else {
                                    this.ctaskPositionWarn = position_data.status;
                                    this.positionRate = this.positionRateCal_(Number(position_data.data)/10,  Number(ctask_data['mt'][0])/10+Number(ctask_data['mt'][1])/10)
                                    return Number(position_data.data)/10 + '/(' + Number(ctask_data['mt'][0]).toFixed(2)/10+'+'+Number(ctask_data['mt'][1]).toFixed(2)/10+')';
                                }
                            }
                        }
                    }
                }
            }
        },

        // 持仓异常判断
        cPositionColor: function () {
            if (this.ctaskPositionWarn) return '#8c0202';
            return '';
        },

        // 手动开平仓所需时间
        closeEndTime: function () {
            if (this.taskCloseData.hasOwnProperty(this.taskId)) {
                let endTime = this.taskCloseData[this.taskId][this.ctaskData.task_children_id]
                if (endTime) {
                    return '平仓预计: '+endTime['plan'];
                }
            }
        }
    },
    methods: {
        // 子任务状态判断
        statusChange(status) {
            // 未运行状态
            if (status == 0) return '#da5634';
            // 运行状态
            else if (status == 2) return '#1ab293'; 
        },

        // 子任务价差计算
        ctaskMarginPrice(ctaskData) {
            let type_order = ['现货', '本周', '次周', '季度', '永续'];
            let a_type_index = type_order.indexOf(this.tradeType.a_type);
            let b_type_index = type_order.indexOf(this.tradeType.b_type);
            if (ctaskData) {
                if (ctaskData.hasOwnProperty('f')) {
                    let a_price = ctaskData['f'][0][0];
                    let b_price = ctaskData['f'][1][0];
                    if (a_type_index >= b_type_index) {// b 为近期, 价差=a_price-b_price
                        return ((Number(a_price) - Number(b_price))/Number(b_price)*100).toFixed(4);
                    } else if (a_type_index < b_type_index) {// a 为近期，价差=b_price-a_price
                        return ((Number(b_price)-Number(a_price))/Number(a_price)*100).toFixed(4);
                    }
                } else if (ctaskData.hasOwnProperty('r')) {
                    let a_price = ctaskData['r'][0][0];
                    let b_price = ctaskData['r'][1][0];
                    if (a_type_index >= b_type_index) {// b 为近期, 价差=a_price-b_price
                        return ((Number(a_price) - Number(b_price))/Number(b_price)*100).toFixed(4);
                    } else if (a_type_index < b_type_index) {// a 为近期，价差=b_price-a_price
                        return ((Number(b_price)-Number(a_price))/Number(a_price)*100).toFixed(4);
                    }
                }
            }
        },

        // 子任务启动
        startCtask(operation) {
            var url = this.$baseUrl + '/task/children/status/update?token='+this.token+'&settingStatus='+operation+'&taskChildrenId='+this.ctaskData.task_children_id;
            put(url).then(resp => {
                if (resp.code == 200) {
                    // 成功后 刷新列表
                    this.$parent.getCtaskArray();
                } else if (resp.code == 4) {// 操作不当
                    this.$notify.error({
                        message: '请先停止主任务，再操作!',
                        title: '提示',
                        offset: 100
                    })
                } else {
                    this.$notify.error({
                        message: resp.info,
                        title: '提示',
                        offset: 100
                    })
                }
            }).catch(error => {
                this.$notify.error({
                    message: error,
                    title: '提示',
                    offset: 100
                })
            })
        },

        // 删除子任务
        deleteCtask() {
            this.$confirm('是否删除该子任务？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                // 确定后的回调
                var url = this.$baseUrl + '/task/children/delete';
                var param = {
                    'token': this.token,
                    'taskChildrenId': this.ctaskData.task_children_id
                };
                del(url, param).then(resp => {
                    if (resp.code == 200) {
                        this.$parent.getCtaskArray();
                        console.log('调用', this)
                        this.$parent.delEvent(this.taskId, this.ctaskData.task_children_id)
                    } else {
                        this.$notify.error({
                            message: resp.info,
                            title: '提示',
                            offset: 100
                        })
                    }
                }).catch(() => {
                    // 取消后的回调
                })
            })
        },
        // 交易价格位数保留
        judgeNum(num) {
            return num.toFixed(4);
        },
        // 交易额位数保留
        tradeNum(num) {
            if (this.currency == 'BTC') {
                // 币种为BTC，交易额除以100
                return Math.round(num/100);
            } else {
                // 其他币种，交易额除以 10
                return Math.round(num/10);
            }
        },

        // 计算仓位 新
        positionRateCal_(top, bottom) {
            let rate = bottom ? Math.round(top/bottom*100) : 0;
            if (rate < 0) return 0;
            else if (rate > 100) return 100;
            return rate
        },

        // 计算仓位
        positionRateCal(data) {
            if (typeof data !== 'undefined') {
                // console.log(data);
                // 如果有数据
                var bottom_data = data.mt[0] + data.mt[1];
                if (bottom_data == 0) return 0;
                if (data.hasOwnProperty('r')) {
                    var finall_position = Math.round(data.r[0][1]/(data.mt[0]+data.mt[1])*100);
                    if (finall_position > 100) return 100;
                    else if (finall_position < 0) return 0;
                    return finall_position;
                } else {
                    var finall_position_f = Math.round(data.f[0][1]/(data.mt[0]+data.mt[1])*100);
                    if (finall_position_f > 100) return 100;
                    else if (finall_position_f < 0) return 0; 
                    return finall_position_f;
                }
            } else {
                return 0;
            }
        },

        // 利润比率计算
        numRate(data) {
            var new_data = data*100
            return new_data.toFixed(2);
        },

        // 利润个数计算
        proCount(data) {
            return data.toFixed(4);
        },

        tradeInfo() {
            var ctaskId = this.ctaskData.task_children_id;
            this.$router.push({
                name: 'TaskTradeInfo',
                query: {
                    id: ctaskId,
                    type: 'ctask'
                }
            })
        },

        // 停止平仓
        endClose() {
            let url = this.$url_CM + '/taskServer/manualend';
            let form_data = new FormData();
            form_data.append('task_id', String(this.taskId))
            post(url, form_data).then(resp => {
                this.$notify.info({
                    message: resp,
                    title: '提示',
                    offset: 100,
                    duration: 1000
                })
            })
        },
    }
}
</script>

<style lang="scss">
    .ctask-info{
        display: flex;
        justify-content: space-between;
        padding: 5px;
        color: #7e7d80;
        // margin-left: 20px;
        // width: 100%;
        .ctask-label {
            display: flex;
            align-items: center;
            vertical-align: middle;
            margin-right: 7px;
        }
        .ctask-right{
            display: flex;
            justify-content: flex-start;
            // flex-wrap: wrap;
            label{
                margin-right: 10px;
                font-size: 13px;
                color: #da5634;
                // padding: 5px 10px;
                border-radius: 3px;
                display: flex;
                align-items: center;
            }
            .el-dropdown{
                .el-button{
                    padding: 4px;
                    background-color: #2a2d2e;
                    border-color: #1e1e1e;
                    color: #97979a;
                    span{
                        i{
                            margin: 0;
                        }
                    }
                }
            }
        }
        .ctask-left{
            display: flex;
            justify-content: flex-start;
            flex-wrap: wrap;
            .ctask-top{
                display: flex;
                justify-content: space-between;
                align-items: center;
                width: 100%;
                .ctask-top-left{
                    display: flex;
                    justify-content: flex-start;
                }
            }
            span{
                margin-right: 5px;
                font-size: 12px;
            }
            .ctask-progress{
                width: 200px;
                margin-right: 5px;
                font-size: 12px;
                .el-progress {
                    top: 50%;
                    transform: translateY(-50%);
                }
                .el-progress__text{
                    font-size: 12px !important;
                }
                .el-progress-bar__outer{
                    background-color: #58595a;
                }
                .el-progress-bar__innerText{
                    display: block !important;
                }
            }
            .ctask-trade-content{
                display: flex;
                justify-content: flex-start;
                flex-wrap: wrap;
                span{
                    margin-right: 5px;
                }
            }
            .fa-level-down{
                color: #1AB394;
            }
            .fa-level-up{
                color: #da5634;
            }
        }
    }
    @media screen and (max-width: 900px) {
        // .ctask-info{
        //     .ctask-left{
        //         .ctask-api-name{
        //             // display: none;
        //         }
        //     }
        // }
    }
    @media screen and (max-width: 800px) {
        .ctask-info{
            .ctask-left{
                .ctask-progress{
                    margin-right: 0;
                    width: 100px;
                    .el-progress{
                        .el-progress__text{
                            display: none;
                        }
                    }
                }
                .ctask-trade-content{
                    span{
                        font-size: 12px;
                    }
                }
            }
        }
    }

    @media screen and (max-width: 420px) {
        .ctask-info{
            .ctask-left{
                .ctask-progress{
                    margin-right: 5px;
                    width: 100px;
                    .el-progress{
                        .el-progress-bar{
                            padding: 0;
                        }
                        .el-progress__text{
                            display: none;
                        }
                    }
                }
                .ctask-trade-content{
                    div{
                        span{
                            font-size: 13px;
                        }
                    }
                    span{
                        font-size: 13px !important;
                    }
                }

                span{
                    font-size: 13px;
                }
            }
        }
    }
</style>
